module.exports = __webpack_public_path__ + "img/xaas-gift.4c0654a.png";